import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=a5553a0c&scoped=true"
import script from "./ingredient.vue?vue&type=script&lang=js"
export * from "./ingredient.vue?vue&type=script&lang=js"
import style0 from "./ingredient.vue?vue&type=style&index=0&id=a5553a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5553a0c",
  null
  
)

export default component.exports